import { RootState } from '../../reducers';

const selectChoosableComparerProductId = (state: RootState) => state?.choosable?.comparerProductId ?? null;

export default selectChoosableComparerProductId;
